(function () {
  const rootSelector = '[data-xmk-fzt-pdp="true"]';
  const targetFaqProductPath = '/products/xtramaker-5-in-1-smart-desktop-dtf-printer-deposit-reservation-1';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function bindHorizontalSwipe({ surfaces, count, getIndex, onNavigate }) {
    if (!surfaces.length || count < 2) return;

    surfaces.forEach((surface) => {
      let drag = null;

      surface.addEventListener('pointerdown', (event) => {
        if (event.button !== undefined && event.button !== 0) return;
        if (event.target.closest('a, button, input, select, textarea, [contenteditable="true"]')) return;

        drag = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          isHorizontal: false,
          isVertical: false
        };
        surface.setPointerCapture && surface.setPointerCapture(event.pointerId);
      });

      surface.addEventListener('pointermove', (event) => {
        if (!drag || drag.id !== event.pointerId) return;

        const deltaX = event.clientX - drag.startX;
        const deltaY = event.clientY - drag.startY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        if (!drag.isHorizontal && !drag.isVertical && (absX > 8 || absY > 8)) {
          drag.isHorizontal = absX > absY * 1.2;
          drag.isVertical = !drag.isHorizontal;
        }

        if (drag.isHorizontal) event.preventDefault();
      });

      const endDrag = (event) => {
        if (!drag || drag.id !== event.pointerId) return;

        const deltaX = event.clientX - drag.startX;
        const deltaY = event.clientY - drag.startY;
        const threshold = Math.max(36, Math.min(86, surface.clientWidth * 0.16));
        const shouldNavigate = Math.abs(deltaX) >= threshold && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;
        const currentIndex = getIndex();
        drag = null;
        surface.releasePointerCapture && surface.releasePointerCapture(event.pointerId);

        if (!shouldNavigate || currentIndex < 0) return;

        const direction = deltaX < 0 ? 1 : -1;
        onNavigate((currentIndex + direction + count) % count);
      };

      surface.addEventListener('pointerup', endDrag);
      surface.addEventListener('pointercancel', endDrag);
    });
  }

  function initCarousel(scope) {
    const carousels = scope.querySelectorAll('[data-xmk-fzt-carousel]');

    carousels.forEach((carousel) => {
      if (carousel.dataset.xmkFztReady === 'true') return;
      carousel.dataset.xmkFztReady = 'true';

      const track = carousel.querySelector('[data-xmk-fzt-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-xmk-fzt-slide]'));
      const prev = carousel.querySelector('[data-xmk-fzt-prev]');
      const next = carousel.querySelector('[data-xmk-fzt-next]');
      const dots = Array.from(carousel.querySelectorAll('[data-xmk-fzt-dot]'));
      if (!track || !slides.length) return;

      let activeIndex = 0;
      let drag = null;
      let jumpTimer = null;
      let scrollFrame = null;

      const normalizeIndex = (index) => (index + slides.length) % slides.length;
      const cleanCloneAttributes = (element) => {
        if (!element?.attributes) return;

        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) {
            element.removeAttribute(attribute.name);
          }
        });
        Array.from(element.children || []).forEach(cleanCloneAttributes);
      };
      const createClone = (slide, index, role) => {
        const clone = slide.cloneNode(true);
        cleanCloneAttributes(clone);
        clone.dataset.xmkFztClone = 'true';
        clone.dataset.xmkFztRole = role;
        clone.dataset.xmkFztIndex = String(index);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((item) => {
          item.setAttribute('tabindex', '-1');
        });

        return clone;
      };

      slides.forEach((slide, index) => {
        slide.dataset.xmkFztRole = 'original';
        slide.dataset.xmkFztIndex = String(index);
      });

      const beforeClones = slides.length > 1 ? slides.map((slide, index) => createClone(slide, index, 'before')) : [];
      const afterClones = slides.length > 1 ? slides.map((slide, index) => createClone(slide, index, 'after')) : [];
      beforeClones.forEach((clone) => track.insertBefore(clone, slides[0]));
      afterClones.forEach((clone) => track.appendChild(clone));

      const getRenderedSlides = () => Array.from(track.querySelectorAll('[data-xmk-fzt-slide]'));
      const slideLeft = (slide) => slide ? slide.offsetLeft : 0;
      const getTargetSlide = (targetIndex) => {
        const normalizedIndex = normalizeIndex(targetIndex);

        if (targetIndex < 0) return beforeClones[normalizedIndex] || slides[normalizedIndex];
        if (targetIndex >= slides.length) return afterClones[normalizedIndex] || slides[normalizedIndex];

        return slides[normalizedIndex];
      };
      const getNearestRenderedSlide = () => {
        const trackLeft = track.scrollLeft;
        let nearestSlide = slides[activeIndex];
        let distance = Number.POSITIVE_INFINITY;

        getRenderedSlides().forEach((slide) => {
          const nextDistance = Math.abs(slide.offsetLeft - trackLeft);
          if (nextDistance < distance) {
            distance = nextDistance;
            nearestSlide = slide;
          }
        });

        return nearestSlide;
      };
      const getTargetIndexForSlide = (slide) => {
        const slideIndex = Number(slide?.dataset.xmkFztIndex) || 0;
        const role = slide?.dataset.xmkFztRole;

        if (role === 'before') return slideIndex - slides.length;
        if (role === 'after') return slideIndex + slides.length;

        return slideIndex;
      };
      const clearJumpTimer = () => {
        if (!jumpTimer) return;

        window.clearTimeout(jumpTimer);
        jumpTimer = null;
      };
      const jumpToOriginal = (index) => {
        clearJumpTimer();
        const previousBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = slideLeft(slides[index]);
        window.requestAnimationFrame(() => {
          track.style.scrollBehavior = previousBehavior;
        });
      };
      const scheduleJump = (index) => {
        clearJumpTimer();
        jumpTimer = window.setTimeout(() => jumpToOriginal(index), 420);
      };
      const updateButtons = () => {
        const disabled = slides.length < 2;

        [prev, next].forEach((button) => {
          if (!button) return;
          button.disabled = disabled;
          button.classList.toggle('is-disabled', disabled);
        });
      };

      const setActive = (index, scroll) => {
        const normalizedIndex = normalizeIndex(index);
        const targetSlide = getTargetSlide(index);
        const targetRole = targetSlide?.dataset.xmkFztRole;

        activeIndex = normalizedIndex;
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
        updateButtons();

        if (scroll) {
          track.scrollTo({ left: slideLeft(targetSlide), behavior: 'smooth' });
          if (targetRole !== 'original') scheduleJump(normalizedIndex);
        } else {
          jumpToOriginal(activeIndex);
        }
      };

      const updateFromScroll = () => {
        const nearest = getNearestRenderedSlide();
        activeIndex = normalizeIndex(Number(nearest?.dataset.xmkFztIndex) || 0);
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
        updateButtons();
      };

      prev && prev.addEventListener('click', () => setActive(activeIndex - 1, true));
      next && next.addEventListener('click', () => setActive(activeIndex + 1, true));
      dots.forEach((dot, index) => dot.addEventListener('click', () => setActive(index, true)));

      track.addEventListener('scroll', () => {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = null;
          updateFromScroll();
        });
      }, { passive: true });
      window.addEventListener('resize', () => setActive(activeIndex, true), { passive: true });

      track.addEventListener('pointerdown', (event) => {
        if (event.button !== undefined && event.button !== 0) return;
        drag = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          startIndex: activeIndex,
          isHorizontal: false,
          isVertical: false,
          startLeft: track.scrollLeft
        };
        track.setPointerCapture && track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!drag || drag.id !== event.pointerId) return;

        const deltaX = event.clientX - drag.startX;
        const deltaY = event.clientY - drag.startY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        if (!drag.isHorizontal && !drag.isVertical && (absX > 8 || absY > 8)) {
          drag.isHorizontal = absX > absY * 1.2;
          drag.isVertical = !drag.isHorizontal;
        }

        if (!drag.isHorizontal) return;

        event.preventDefault();
        track.scrollLeft = drag.startLeft - deltaX;
      });

      const endDrag = (event) => {
        if (!drag || drag.id !== event.pointerId) return;
        const deltaX = event.clientX - drag.startX;
        const deltaY = event.clientY - drag.startY;
        const threshold = Math.max(36, Math.min(86, track.clientWidth * 0.16));
        const shouldNavigate = Math.abs(deltaX) >= threshold && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;
        const targetIndex = shouldNavigate
          ? drag.startIndex + (deltaX < 0 ? 1 : -1)
          : getTargetIndexForSlide(getNearestRenderedSlide());

        drag = null;
        track.releasePointerCapture && track.releasePointerCapture(event.pointerId);
        setActive(targetIndex, true);
      };

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') setActive(activeIndex - 1, true);
        if (event.key === 'ArrowRight') setActive(activeIndex + 1, true);
      });

      setActive(0, false);
    });
  }

  function initCompare(scope) {
    scope.querySelectorAll('[data-xmk-fzt-compare]').forEach((compare) => {
      if (compare.dataset.xmkFztReady === 'true') return;
      compare.dataset.xmkFztReady = 'true';

      const tabs = Array.from(compare.querySelectorAll('[data-xmk-fzt-compare-tab]'));
      const cards = Array.from(compare.querySelectorAll('[data-xmk-fzt-product-key]'));
      const keys = tabs.map((tab) => tab.dataset.xmkFztCompareTab).filter(Boolean);

      const setActive = (key) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.xmkFztCompareTab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        cards.forEach((card) => {
          card.classList.toggle('is-featured', card.dataset.xmkFztProductKey === key);
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => setActive(tab.dataset.xmkFztCompareTab));
      });

      bindHorizontalSwipe({
        surfaces: Array.from(compare.querySelectorAll('.xmk-fzt-compare-grid, .xmk-fzt-tabs')),
        count: keys.length,
        getIndex: () => keys.indexOf((tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0])?.dataset.xmkFztCompareTab),
        onNavigate: (index) => setActive(keys[index])
      });

      const current = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
      if (current) setActive(current.dataset.xmkFztCompareTab);
    });
  }

  function isTargetFaqProductPage() {
    return window.location.pathname.indexOf(targetFaqProductPath) !== -1;
  }

  function ensureTargetFaqStyle() {
    if (!isTargetFaqProductPage() || document.getElementById('xmk-fzt-faq-runtime-style')) return;

    const style = document.createElement('style');
    style.id = 'xmk-fzt-faq-runtime-style';
    style.textContent = [
      '@media screen and (min-width: 750px) {',
      '  [data-xmk-fzt-pdp="true"] .section-xmk-pdp-about .xmk-about { box-shadow: none !important; }',
      '  [data-xmk-fzt-pdp="true"] .section-xmk-pdp-about + .shopify-section [class*="goc-faq-"] { position: relative !important; z-index: 3 !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] { min-height: 989px !important; padding: 89px 0 82px !important; background: #000000 !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-container { width: min(calc(100% - 48px), 1040px) !important; max-width: 1040px !important; margin: 0 auto !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-header { margin-bottom: 29px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-header h2 { font-size: 48px !important; font-weight: 700 !important; line-height: 56px !important; letter-spacing: -0.32px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-list { gap: 24px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-deposit-policy-link { position: relative !important; display: block !important; min-height: 29px !important; padding: 0 40px 10px 0 !important; border-bottom: 1px solid var(--faq-line-color) !important; color: transparent !important; font-size: 0 !important; line-height: 0 !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-deposit-policy-link a { display: none !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-deposit-policy-link::before { content: "*Click here to view full deposit and policy."; display: block; color: #ffffff; font-size: 18px; font-weight: 500; line-height: 18px; letter-spacing: -0.32px; text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25); }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-deposit-policy-link::after { content: ""; position: absolute; top: 1px; right: 4px; width: 12px; height: 12px; border-right: 1.4px solid #ffffff; border-bottom: 1.4px solid #ffffff; transform: rotate(45deg); }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-question { min-height: 52px !important; padding: 0 0 34px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-question h3 { max-width: 990px !important; padding-right: 40px !important; font-size: 18px !important; font-weight: 500 !important; line-height: 18px !important; letter-spacing: -0.32px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-answer-content { max-width: 990px !important; font-size: 16px !important; line-height: 24px !important; letter-spacing: 0 !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-item[open] .faq-question { min-height: auto !important; padding-bottom: 0 !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-item[open] .faq-answer-content { padding: 16px 0 35px !important; }',
      '  [data-xmk-fzt-pdp="true"] .product-buy.xmk-fzt-faq-active, [data-xmk-fzt-pdp="true"] .product-buy.xmk-fzt-faq-overlap-active, [data-xmk-fzt-pdp="true"] .product-buy.xmk-fzt-support-overlap-active { opacity: 0 !important; pointer-events: none !important; transform: translateY(100%) !important; }',
      '}',
      '@media screen and (max-width: 749px) {',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] { min-height: 769px !important; padding: 40px 0 38.5px !important; background: #000000 !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-container { width: 345px !important; max-width: calc(100% - 30px) !important; margin: 0 auto !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-header { margin-bottom: 24.5px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-header h2 { font-size: 25px !important; font-weight: 700 !important; line-height: 30px !important; letter-spacing: -0.16px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-deposit-policy-link { display: none !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-list { gap: 12px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-question { min-height: 51px !important; padding: 0 0 15px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-question h3 { max-width: 318px !important; padding-right: 18px !important; font-size: 14px !important; font-weight: 500 !important; line-height: 18px !important; letter-spacing: -0.16px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-item[open] .faq-question { min-height: auto !important; padding-bottom: 0 !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-item[open] .faq-question h3 { max-width: 282px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-answer-content { max-width: 300.5px !important; font-size: 12px !important; line-height: 16px !important; letter-spacing: -0.16px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-item[open] .faq-answer-content { padding: 8px 0 15px !important; }',
      '  [data-xmk-fzt-pdp="true"] [class*="goc-faq-"] .faq-item:last-child .faq-question { min-height: 34px !important; padding-bottom: 0 !important; border-bottom: 0 !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function normalizeTargetFaqQuestions(faq) {
    if (!isTargetFaqProductPage() || !faq) return;

    faq.querySelectorAll('.faq-question h3').forEach((heading) => {
      if (heading.textContent.indexOf('What about shipping fees and taxes?') !== -1) {
        heading.textContent = 'Is the XtraMaker M1/M1 Pro available for worldwide shipping?';
      }
    });
  }

  function initFaqStickyBuyGuard(scope) {
    const root = (scope || document).querySelector
      ? (scope || document).querySelector(rootSelector)
      : null;
    const pageRoot = root || document.querySelector(rootSelector);
    if (!pageRoot) return;

    const faq = pageRoot.querySelector('[class^="goc-faq-"]');
    const support = isTargetFaqProductPage() ? pageRoot.querySelector('.xmk-fzt-support') : null;
    const productBuy = pageRoot.querySelector('.product-buy');
    const desktopMedia = window.matchMedia('(min-width: 750px)');

    if (faq && isTargetFaqProductPage()) {
      ensureTargetFaqStyle();
      normalizeTargetFaqQuestions(faq);
    }

    if (pageRoot.dataset.xmkFztFaqGuardReady === 'true') return;
    if (!productBuy || (!faq && !support)) return;

    pageRoot.dataset.xmkFztFaqGuardReady = 'true';

    const setFaqHidden = (hidden) => {
      productBuy.classList.toggle('xmk-fzt-faq-active', hidden && desktopMedia.matches);
      productBuy.classList.toggle('xmk-fzt-faq-overlap-active', hidden && desktopMedia.matches);
    };
    const setSupportHidden = (hidden) => {
      productBuy.classList.toggle('xmk-fzt-support-overlap-active', hidden && desktopMedia.matches);
    };
    const isInViewport = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    };

    if (typeof IntersectionObserver !== 'undefined') {
      if (faq) {
        const faqObserver = new IntersectionObserver((entries) => {
          const faqVisible = entries.some((entry) => entry.isIntersecting);
          setFaqHidden(faqVisible);
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0
        });

        faqObserver.observe(faq);
      }

      if (support) {
        const supportObserver = new IntersectionObserver((entries) => {
          const supportVisible = entries.some((entry) => entry.isIntersecting);
          setSupportHidden(supportVisible);
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0
        });

        supportObserver.observe(support);
      }
    }

    const handleDesktopChange = () => {
      if (!desktopMedia.matches) {
        setFaqHidden(false);
        setSupportHidden(false);
        return;
      }

      setFaqHidden(isInViewport(faq));
      setSupportHidden(isInViewport(support));
    };

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', handleDesktopChange);
    } else if (desktopMedia.addListener) {
      desktopMedia.addListener(handleDesktopChange);
    }
    window.addEventListener('scroll', handleDesktopChange, { passive: true });
    window.addEventListener('resize', handleDesktopChange, { passive: true });
    handleDesktopChange();
  }

  function initProductsCacheFallback(scope) {
    const root = (scope || document).querySelector
      ? (scope || document).querySelector(rootSelector)
      : null;
    const pageRoot = root || document.querySelector(rootSelector);
    if (!pageRoot || document.getElementById('xmk-fzt-products-cache-js-fallback')) return;

    const products = pageRoot.querySelector('.xmk-fzt-products');
    if (!products) return;

    const style = document.createElement('style');
    style.id = 'xmk-fzt-products-cache-js-fallback';
    style.textContent = [
      '@media screen and (max-width: 749px) {',
      '  [data-xmk-fzt-pdp="true"] .xmk-fzt-products {',
      '    background: linear-gradient(180deg, #f5f5f7 0%, #f5f5f7 55.68%, #fff 100%) !important;',
      '    padding: 60px 0 0 !important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function init(scope) {
    const target = scope || document;
    initCarousel(target);
    initCompare(target);
    initFaqStickyBuyGuard(target);
    initProductsCacheFallback(target);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-xmk-fzt-ready="true"]').forEach((node) => {
      node.dataset.xmkFztReady = 'false';
    });
  });

  window.XtraMakerFztPdp = {
    init,
    rootSelector
  };
})();
